module.exports = __webpack_public_path__ + "img/ATRC Platform - Privacy Policy -6.5047bcbf.png";